<script>
	import { getContext } from "svelte";
	import { key } from "./mapbox.js";
	import journey from "../../../stores/journey.js";
	import cairn from "../../../stores/cairn.js";
	import windows from "../../../stores/windows.js";
	import semaphore from "../../../stores/semaphore.js";
	import { arrayFromCoordinateDirctionary } from "../../../helpers/geo.js";
	import isMobile from "../../../helpers/mobile.js";

	const map = getContext(key).map();

	$: styleForCairn = (cairn) => {
		try {
			const location = map.project(arrayFromCoordinateDirctionary(cairn));

			const zIndex = $journey.location ? $journey.location.latitude : 0;

			return (
				`transform: translateX(calc(${location.x.toFixed(2)}px - 50%))` +
				`translateY(calc(${location.y.toFixed(2)}px  - 50%)) ` +
				`rotate(${cairn.angle.toFixed(2)}deg);` +
				`z-index: ${zIndex};`
			);
		} catch (_0) {
			return "display: none";
		}
	};

	function imageForCairn(cairn) {
		return `data:image/svg+xml,${encodeURIComponent(cairn.top)}`;
	}

	function didClickCairn(e, cairn) {
		const id = windows.open("cairn", { cairn });

		if (isMobile === false) {
			windows.move(id, e.clientX + 40.0, e.clientY - 100.0);
		}

		windows.focus(id);
	}

	function didMouseOverCairn() {
		semaphore.pause("Admiring a cairn someone built.");
	}

	function didMouseOutCairn() {
		semaphore.resume();
	}
</script>

<div class="cairns">
	{#each $cairn.all as cairn}
		<img
			style={styleForCairn(cairn)}
			src={imageForCairn(cairn)}
			on:click={(e) => didClickCairn(e, cairn)}
			on:mouseenter={didMouseOverCairn}
			on:mouseleave={didMouseOutCairn} />
	{/each}
</div>

<style>
	.cairns {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
	}

	img {
		user-drag: none;
		-webkit-user-drag: none;
		position: absolute;
		transform-origin: center center;
		cursor: pointer;
		width: 30px;
		height: 30px;
		object-fit: contain;
		pointer-events: all;
	}

	img:hover {
		filter: brightness(1.2);
	}
</style>
